import React from 'react';
import {SingleGameComponent} from '../../single-game/single-game.component';
import {observer} from 'mobx-react';
import {OrbitComponentWithState} from '../../base-components/orbit-component-with-state/orbit-component-with-state';

export interface GamesGridBatchComponentProps {
  batchIndex: number;
  gameTypes: number[];
  aiEngine: string;
  seoCategory: string;
  skipIntermediatePage: boolean;
  disableGameInfoHover: boolean;
  listTitleTranslationKey: string;
  templateType?: string;
  useSquareIcons?: boolean;
}

export interface GamesGridBatchComponentState {
  isResolved: boolean;
}

const NUMBER_OF_GAMES_IN_BATCH = 20;

@observer
export class GamesGridBatchComponent extends OrbitComponentWithState<GamesGridBatchComponentProps, GamesGridBatchComponentState> {

    state = {
        isResolved: false
    };

    private _renderOneGame(gameType, gameIndex) {


        return (
            <SingleGameComponent key={gameType}
                                 aiEngine={this.props.aiEngine}
                                 gameType={gameType}
                                 gameIndex={gameIndex}
                                 seoCategory={this.props.seoCategory}
                                 listTitle={this.props.listTitleTranslationKey}
                                 templateType={this.props.templateType}
                                 skipIntermediatePage={this.props.skipIntermediatePage}
                                 useSquareIcons={this.props.useSquareIcons}
                                 disableGameInfoHover={this.props.disableGameInfoHover}/>
        );
    }

    private _intersectionObserver: IntersectionObserver | null;

    private _intersectionObserverCallback = (entries: IntersectionObserverEntry[]) => {
        if (entries[0].intersectionRatio > 0 || entries[0].isIntersecting) {
            this._destroyIntersectionObserver();
            this.setState({
                isResolved: true
            });
        }
    };

    private _createIntersectionObserver(element: HTMLElement) {

        this._destroyIntersectionObserver(); // just in case this is called twice for this component we want to discard the existing intersection observer and create a new one

        this._intersectionObserver = new IntersectionObserver(this._intersectionObserverCallback, {
            root: this.services.mainScreen.mainScreenElement, //if we don't attach to the correct scroll container (the one that has the scroll bars) then the rootMargin doesn't work correctly
            rootMargin: '400px',
            threshold: 0.1
        });

        this._intersectionObserver.observe(element);
    }


    componentWillUnmount() {
      super.componentWillUnmount();
      this._destroyIntersectionObserver();
    }

    private _destroyIntersectionObserver() {
        if (this._intersectionObserver) {
            this._intersectionObserver.disconnect();
            this._intersectionObserver = null;
        }
    }

    private _captureThresholdElement = (element: HTMLElement | null) => {
        if (element) {
            this._createIntersectionObserver(element)
        }
    };

    private _renderNextBatch() {
        const nextBatchGameTypes = this.props.gameTypes.slice(NUMBER_OF_GAMES_IN_BATCH);
        if(nextBatchGameTypes.length === 0) {
            return null;
        }

        const propsForNextBatch = {
            ...this.props,
            batchIndex: this.props.batchIndex + 1,
            gameTypes: nextBatchGameTypes
        };

        return (<GamesGridBatchComponent key={`Batch_${propsForNextBatch.batchIndex}`} {...propsForNextBatch}/>);
    }

    private _renderCurrentBatch() {
        const batchIndexOffset = this.props.batchIndex * NUMBER_OF_GAMES_IN_BATCH;
        const currentBatchGameTypes = this.props.gameTypes.slice(0, NUMBER_OF_GAMES_IN_BATCH);
        return (
            <>
                {currentBatchGameTypes.map((gameType, index) => this._renderOneGame(gameType, batchIndexOffset + index))}
                {this._renderNextBatch()}
            </>
        );
    }

    render() {

        if(this.props.batchIndex === 0 || this.state.isResolved) {
          return this._renderCurrentBatch();
        }

        return (
            <div style={{width: '100%', height: '10px'}} ref={this._captureThresholdElement}></div>
        )
    }
}
